export class ExpertOptionCondition {
    constructor(condition) {
        this.condition = condition

        this.isValid = ExpertOptionCondition.checkIfValid(condition)

        if (!this.isValid) {
            throw new Error(`Not a valid condition: '${condition}'!`)
        }
    }

    static checkIfValid(condition) {
        condition = condition.trim()

        if (!condition) {
            return false
        }

        return this.listOfValidConditions.includes(condition)

    }

    static listOfValidConditions = [
        'and',
        'or'
    ]

    static And = Object.freeze(new this('and'))
    static Or = Object.freeze(new this('or'))
}